<template>
  <el-form
    :model="params"
    :rules="rules"
    hide-required-asterisk
    class="login__form"
    label-width="27px"
    ref="form"
  >
    <el-form-item
      v-input-border="{ className: 'is-focus' }"
      prop="password"
      class="login__password border--bottom"
    >
      <i
        slot="label"
        class="b-icon-password"
      />
      <el-input
        type="password"
        v-model="params.password"
        placeholder="新密码"
        class="border--hidden"
        @keypress.native.enter="submit()"
      />
    </el-form-item>
    <el-form-item
      v-input-border="{ className: 'is-focus' }"
      prop="password_confirmation"
      class="login__password border--bottom"
    >
      <i
        slot="label"
        class="b-icon-password"
      />
      <el-input
        type="password"
        v-model="params.password_confirmation"
        placeholder="确认密码"
        class="border--hidden"
        @keypress.native.enter="submit()"
      />
    </el-form-item>
    <el-form-item
      label-width="0"
      class="login__form-footer text-center"
    >
      <el-button
        type="primary"
        size="large"
        class="login__submit"
        round
        :loading="$loadings.submit"
        @click="submit()"
      >重置密码</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getUrlKey } from '@/utils'
import { UPDATE_TOKEN } from 'store/mutation-types'
import * as api from 'index/api'
export default {
  name: 'ForgotPassword',
  data () {
    return {
      params: {
        password: '',
        password_confirmation: ''
      },
      rules: {
        password: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入密码'))
              } else {
                if (this.params.password_confirmation !== '') {
                  this.$refs.form.validateField('password_confirmation')
                }
                callback()
              }
            },
            trigger: 'submit'
          }
        ],
        password_confirmation: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.params.password) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
            trigger: 'submit'
          }
        ]
      }
    }
  },

  methods: {
    redirectToModule () {
      this.$emit('redirectToModule', 'login')
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$store.dispatch(UPDATE_TOKEN).then(token => {
            api.resetPassword({
              ...this.params,
              token: getUrlKey('token') || ''
            }).then(() => {
              this.$message({
                type: 'info',
                message: '重置成功，请重新登录'
              })
              this.$store.commit(UPDATE_TOKEN, token)
              this.$emit('redirectToModule', 'login')
            }).catch(err => {
              const { data } = err || {}
              const { message: msg = err.message } = data || {}
              let message = msg || '重置密码失败'
              this.$message.error(message)
            })
          })
        }
      })
    }
  },
  created () {
    this.params = {
      password: '',
      email: ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
